/**
 * @created on 2017/9/19
 * @author laixinyu <laixinyualex@gmail.com>
 **/

import Bridge from '../Bridge/Bridge'

/**
 *
 * @param str
 */
function getRunTime(str) {
  let result
  let _href = window.location.href.split('.')[0]

  _href.replace(/(qc|box)\d+/, s => {
    result = str.replace(/\./, `-${s}.`)
  })

  if (!result) {
    result = str
  }

  return result
}

/**
 * 判断两个版本字符串的大小
 * @param  {string} v1 原始版本
 * @param  {string} v2 目标版本
 * @return {number}    如果原始版本大于目标版本，则返回大于0的数值, 如果原始小于目标版本则返回小于0的数值。0当然是两个版本都相等拉。
 */
function compareVersion(v1, v2) {
  if (!v1 || !v2) {
    return -1
  }

  let _v1 = v1.split('.')
  let _v2 = v2.split('.')
  let _r = _v1[0] - _v2[0]

  return _r === 0 && v1 !== v2
    ? compareVersion(_v1.splice(1).join('.'), _v2.splice(1).join('.'))
    : _r
}

/**
 * 替换\n\r换行符
 * @param str
 * @returns {void|*|XML|string}
 */
function linebreakReplace(str) {
  return str.replace(/[\n\r]/g, '<br>')
}

/**
 * 数字超过1000自动换算成k并且保留一位小数 超过10000自动换成W且保留一位小数
 * @created on 2017/9/18
 * @author laixinyu <laixinyualex@gmail.com>
 *
 * roundDown向下舍去 默认toFixed四舍五入
 **/

function unitConversion(number, roundDown = false) {
  let num = Number(number)

  if (num >= 1000 && num < 10000) {
    num = num / 1000
    if (roundDown) {
      return Math.floor(num * 10) / 10 + 'k'
    } else {
      return num.toFixed(1) + 'k'
    }
  } else if (num >= 10000) {
    num = num / 10000
    if (roundDown) {
      return Math.floor(num * 10) / 10 + 'w'
    } else {
      return num.toFixed(1) + 'w'
    }
  } else {
    return num
  }
}

/**
 * 动态加载js
 * @param url
 * @param callback
 */
function loadScript(url, callback) {
  var script = document.createElement('script')
  script.type = 'text/javascript'
  if (typeof callback !== 'undefined') {
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null
          callback()
        }
      }
    } else {
      script.onload = function() {
        callback()
      }
    }
  }
  script.src = url

  document.body.appendChild(script)
}

/**
 * 跳转到app打开页面，如果无app则跳去下载页面
 * @param href
 */

function goApp(href, utmSource) {
  let src = `yixinli://${href}`
  let ifr

  let UA = window.navigator.userAgent.toUpperCase()
  // 判断微信环境
  if (/MICROMESSENGER/i.test(UA)) {
    if (window.toast) {
      window.toast('微信用户需要点击右上角菜单，使用“浏览器”打开~', 3000)
    } else {
      alert('微信用户需要点击右上角菜单，使用“浏览器”打开~')
    }

    return
  }

  if (/(IPHONE|IPAD|IPOD|IOS)/i.test(UA)) {
    window.location.href = src
  } else {
    // window.location.href = src;
    ifr = document.createElement('iframe') // open_question_detail?question_id=123
    ifr.src = src
    // alert(ifr);
    // alert(ifr.src);
    ifr.style.display = 'none'

    document.body.appendChild(ifr)
  }

  window.setTimeout(function() {
    if (ifr) document.body.removeChild(ifr)
    let utm = utmSource ? `?utm_source=${utmSource}` : ''
    window.location.href = 'https://m.xinli001.com/download' + utm
  }, 2000)
}

/**
 * cookie操作
 * @param c_name cookie名
 * @param c_val 值
 * @param long  时长
 */
function setCookie(c_name, c_val, long) {
  if (typeof c_name === 'string' && typeof c_val === 'string') {
    var exdate = new Date()
    exdate.setDate(exdate.getDate() + long)
    document.cookie =
      c_name +
      '=' +
      escape(c_val) +
      (long == null ? '' : ';expires=' + exdate.toGMTString())
  }
}

/**
 * cookie操作
 * @param c_name cookie名
 * @param c_val 值
 * @param long  时长
 */
function getCookie(c_name) {
  if (document.cookie.length > 0) {
    c_start = document.cookie.indexOf(c_name + '=')
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1
      c_end = document.cookie.indexOf(';', c_start)
      if (c_end == -1) c_end = document.cookie.length
      return unescape(document.cookie.substring(c_start, c_end))
    }
  }
  return ''
}

function debounce(action, idle) {
  let last = null
  return function() {
    let ctx = this
    let args = arguments
    clearTimeout(last)
    last = setTimeout(function() {
      action.apply(ctx, args)
    }, idle)
  }
}

function throttle(fn, interval = 300) {
  let canRun = true
  return function() {
    if (!canRun) return
    canRun = false
    setTimeout(() => {
      fn.apply(this, arguments)
      canRun = true
    }, interval)
  }
}

function supportCss3(style) {
  var prefix = ['webkit', 'Moz', 'ms', 'o']
  var i
  var humpString = []
  var htmlStyle = document.documentElement.style
  var _toHumb = function(string) {
    return string.replace(/-(\w)/g, function($0, $1) {
      return $1.toUpperCase()
    })
  }

  for (i in prefix) {
    humpString.push(_toHumb(prefix[i] + '-' + style))
  }

  humpString.push(_toHumb(style))

  for (i in humpString) {
    if (humpString[i] in htmlStyle) return true
  }

  return false
}

function isSupportSticky() {
  let prefixTestList = ['', '-webkit-', '-ms-', '-moz-', '-o-']
  let stickyText = ''
  for (let i = 0; i < prefixTestList.length; i++) {
    stickyText += 'position:' + prefixTestList[i] + 'sticky;'
  }
  // 创建一个dom来检查
  let div = document.createElement('div')
  let body = document.body
  div.style.cssText = 'display:none;' + stickyText
  body.appendChild(div)
  let isSupport = /sticky/i.test(window.getComputedStyle(div).position)
  body.removeChild(div)
  div = null
  return isSupport
}

function getPlatform() {
  const IS_APP =
    window.navigator.userAgent.toLowerCase().indexOf('yixinliapp') !== -1
  var ua = navigator.userAgent // 获取浏览器UA
  var isWindowsPhone = /(?:Windows Phone)/.test(ua)
  var isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
  var isAndroid = /(?:Android)/.test(ua)
  var isFireFox = /(?:Firefox)/.test(ua)
  var isChrome = /(?:Chrome|CriOS)/.test(ua)
  var isWechat = /(?:MicroMessenger)/.test(ua)
  var isTablet =
    /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid && !/(?:Mobile)/.test(ua)) ||
    (isFireFox && /(?:Tablet)/.test(ua))
  var isiPhone = /(?:iPhone)/.test(ua) && !isTablet
  var isPc = !isiPhone && !isAndroid && !isSymbian
  var isYixinliApp = /(?:yixinliApp)/.test(ua)
  var yixinliAPPVersion = IS_APP
    ? ua.match(/YIXINLIAPP;*.*.*/i)[0].split(';')[1]
    : null
  return {
    isWechat: isWechat,
    isTablet: isTablet,
    isiPhone: isiPhone,
    isAndroid: isAndroid,
    isPc: isPc,
    isYixinliApp: isYixinliApp,
    yixinliAPPVersion: yixinliAPPVersion
  }
}

function GetRequest() {
  var url = location.search
  var theRequest = new Object()
  if (url.indexOf('?') != -1) {
    var str = url.substr(1)
    var strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}

function versionfunegt(ver1, ver2) {
  if (!ver1 || !ver2) return
  const version1pre = parseFloat(ver1)
  const version2pre = parseFloat(ver2)
  const version1next = +ver1.replace(version1pre + '.', '')
  const version2next = +ver2.replace(version2pre + '.', '')
  if (version1pre > version2pre) {
    return true
  } else if (version1pre < version2pre) {
    return false
  } else {
    if (version1next >= version2next) {
      return true
    } else {
      return false
    }
    // return version1next >= version2next
  }
}

/**
 * 移动端跳转到下载，app内调协议更新
 */
function updateOrDownLoadApp() {
  const ua = window.navigator.userAgent
  const isApp = ua.toLocaleLowerCase().indexOf('yixinliapp') > -1
  const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
  if (isApp) {
    let bridge = new Bridge()
    const _version =
      GetQueryString('_version') ||
      GetQueryString('_version', window.location.hash)
    if (versionfunegt(_version, '5.2.1')) {
      bridge.call('doUpgrade')
    } else {
      if (isAndroid) {
        // bridge.call('openWebView', {
        //   url: 'http://app-global.pgyer.com/3032d1cee33cd139f310f9f1da85caa9.apk?attname=yixinli-debug-20180816-175409.apk&sign=730cd838ae4b4c83f6af335e669bd51c&t=5b7671c5', // sdk原型上链接
        //   isCurrentPageOpen: 0
        // })
        const iframe = document.createElement('iframe')
        const src =
          'https://filecdn.xinli001.com/android_patch/yixinli-release-20180801-165718_510_15_home_sign.apk'
        iframe.src = src
        iframe.style = `width:0;height:0;overflow:hidden;position: absolute;`
        document.body.appendChild(iframe)
        setTimeout(() => document.body.removeChild(iframe), 2000)
      } else {
        // 只能是a链接点击
        const a = document.createElement('a')
        const href =
          'http://a.app.qq.com/o/simple.jsp?open_by_broswer=1&pkgname=com.xinli.yixinli'
        a.href = href
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    }
  } else {
    goApp()
  }
}

// 获取URL 中 Query
function GetQueryString(name, url) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = (url || window.location.search.substr(1)).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

function objectToQueryString(searchParams) {
  let queryString = ''
  Object.keys(searchParams).map(key => {
    queryString += key + '=' + searchParams[key] + '&'
  })
  return queryString.substring(0, queryString.length - 1)
}

// 用正则表达式实现html转码
function htmlEncode(str) {
  var s = ''
  if (str.length === 0) return ''
  s = str.replace(/&/g, '&amp;')
  s = s.replace(/</g, '&lt;')
  s = s.replace(/>/g, '&gt;')
  s = s.replace(/ /g, '&nbsp;')
  s = s.replace(/\'/g, '&#39;')
  s = s.replace(/\"/g, '&quot;')
  s = s.replace(/%/g, '&#37;')
  return s
}

// 用正则表达式实现html解码
function htmlDecode(str) {
  var s = ''
  if (str.length === 0) return ''
  s = str.replace(/&amp;/g, '&')
  s = s.replace(/&lt;/g, '<')
  s = s.replace(/&gt;/g, '>')
  s = s.replace(/&nbsp;/g, ' ')
  s = s.replace(/&#39;/g, "'")
  s = s.replace(/&quot;/g, '"')
  s = s.replace(/&#37;/g, '%')
  return s
}

function getMP() {
  var userAgent = navigator.userAgent

  if (userAgent.indexOf('AlipayClient') > -1) {
    // 支付宝小程序
    return true
  } else if (/QQ/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
    // QQ 小程序
    return true
  } else if (/miniProgram/i.test(userAgent)) {
    // 微信小程序
    return true
  } else if (/toutiaomicroapp/i.test(userAgent)) {
    // 头条小程序
    return true
  } else if (/swan/i.test(userAgent)) {
    // 百度小程序
    return true
  } else {
    return false
  }
}

module.exports = {
  getRunTime,
  compareVersion,
  linebreakReplace,
  goApp,
  GetQueryString,
  objectToQueryString,
  loadScript,
  unitConversion,
  setCookie,
  getCookie,
  debounce,
  throttle,
  supportCss3,
  isSupportSticky,
  versionfunegt,
  updateOrDownLoadApp,
  getPlatform,
  GetRequest,
  htmlEncode,
  htmlDecode,
  getMP
}



// WEBPACK FOOTER //
// ./src/public-resource/libs/utils/index.js